import AclList from 'ui/Element/Acl/List'
import ListActionsHOC from 'platform/react/hoc/list/actions'

const AclActionsList = ListActionsHOC(AclList)

export default AclActionsList
